import { Spin } from 'antd';
import styles from './index.module.sass';

export const UniversalLoader = ({
  title,
  error,
}: {
  title?: string | JSX.Element;
  error?: boolean | Error | string;
}) => {
  return (
    <div className={styles.root}>
      {error ? (
        <span>ошибка загрузки данных</span>
      ) : (
        <>
          <Spin size="large" />
          {title && <span>{title}</span>}
        </>
      )}
    </div>
  );
};
